import React from "react";
import ICICI from "../../EntertrpriseComponents/EnterpriseCaseStudyComponents/ICICI";
import EnterpriseHeader from "../../EntertrpriseComponents/EnterpriseHeader";
import SwitchtoManufacturing from "../../EntertrpriseComponents/SwitchtoManufacturing";
import EnterpriseFooter from "../../EntertrpriseComponents/EnterpriseFooter";
import Whatsapp from "../../../Common Components/Whatsapp";
import { Helmet } from 'react-helmet';

function IciciCaseStudyPage() {
  return (
    <div>
      <Helmet>
        <title>Calid Technologies - ICICI Case Study - HPE/Aruba, Palo Alto, Dell, Lenovo, Radmin, Altai Dealers Distributors in Pune Mumbai Maharashtra India</title>
        <meta name="description" content="Explore how Calid Technologies designed, supplied, and deployed a secure wireless network for ICICI Bank. Learn about the challenges, strategies, and outcomes that enhanced the bank's IT infrastructure." />
        <meta name="keywords" content="ICICI Bank Technology Solutions,Secure Networking for Banks,Wireless Network Deployment,Bank IT Solutions,Calid Technologies Case Study,Wireless Network Supply,Network Security Solutions,IT Infrastructure Deployment,Secure Wireless Network,ICICI Bank Network Design" />
        <meta name="author" content="Calid Technologies" />
        <meta name="robots" content="index, follow" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="ICICI Case Study" />
        <meta property="og:description" content="Explore how Calid Technologies designed, supplied, and deployed a secure wireless network for ICICI Bank. Learn about the challenges, strategies, and outcomes that enhanced the bank's IT infrastructure." />
        <meta property="og:image" content="URL to your image" />
        <meta property="og:url" content="https://www.calidtech.com" />
        <meta property="og:site_name" content="Calid Technologies" />
        <meta property="fb:app_id" content="Your Facebook App ID" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Your Page Title" />
        <meta name="twitter:description" content="Your website description here" />
        <meta name="twitter:image" content="URL to your image" />
        <meta name="twitter:site" content="@YourTwitterHandle" />
        <meta name="twitter:creator" content="@YourTwitterHandle" />

        <meta itemprop="name" content="ICICI Case Study" />
        <meta itemprop="description" content="Discover how Calid Technologies provided organization-wide consulting and set up the ICT infrastructure for Karkinos, utilizing advanced products like Cisco CBS350 series and Ruckus R650. Explore the comprehensive solutions and successful implementation." />
        <meta itemprop="image" content="URL to your image" />

        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
        <meta name="apple-mobile-web-app-title" content="Calid Technologies" />
        <meta name="application-name" content="Calid Technologies" />

        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="URL to your tile image" />
        <meta name="theme-color" content="#ffffff" />

        <link rel="icon" href="/favicon.ico" />
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
        <link rel="manifest" href="/manifest.json" />
        <link rel="canonical" href="https://calidtech.com/IciciCaseStudyPage" />
      </Helmet>
      <EnterpriseHeader />
      <ICICI />
      <EnterpriseHeader />
            {/* <Whatsapp /> */}

      <SwitchtoManufacturing />
      <EnterpriseFooter />
    </div>
  );
}

export default IciciCaseStudyPage;
